export enum LFALevelType {
  BEGINNER = 'BEGINNER',
  LEVEL_TEST = 'LEVEL_TEST',
}
